/**
 * 国内版区域配置
 * 所有国内版特有的数据、导航、联系方式等都在这里定义
 * 修改国内版内容时，只需修改此文件，无需修改视图组件
 */
export default {
  // 区域标识
  region: 'cn',
  // 区域显示名
  name: '国内版',
  // 游戏名称
  gameName: '代号：真修仙',
  // 公司名称
  companyName: '盛剑游',
  // 默认语言
  defaultLocale: 'zh',

  // 导航菜单
  navItems: [
    { titleKey: 'message.home', path: '/cn/home', children: [] },
    {
      titleKey: 'message.about',
      path: '/cn/about',
      children: [
        { title: '公司简介', path: '/cn/about' }
      ]
    },
    { titleKey: 'message.contact', path: '/cn/contact', children: [] }
  ],

  // 可用页面（用于路由校验、站点地图等）
  pages: ['home', 'about', 'contact', 'news', 'games', 'download', 'community'],

  // 页脚信息
  footer: {
    icp: '琼ICP备2025060132号'
  },

  // 联系方式
  contactInfo: [
    {
      title: '商务合作',
      content: [
        { text: 'shengjianyouhn@163.com' },
        { text: '欢迎各类商务合作咨询' }
      ]
    },
    {
      title: '简历投递',
      content: [
        { text: 'shengjianyouhn@163.com' },
        { text: '欢迎优秀人才投递简历' }
      ]
    },
    {
      title: '官方邮箱',
      content: [
        { text: 'shengjianyouhn@163.com' },
        { text: '问题反馈与建议' }
      ]
    },
    {
      title: '公司地址',
      content: [
        { text: '海南省海口市秀英区永万路南光中心1栋1220' },
        { text: '邮编：570100' }
      ]
    }
  ],

  // 下载渠道
  downloadChannels: [
    { name: 'Windows 下载', type: 'windows' },
    { name: 'Mac 下载', type: 'mac' }
  ],

  // 系统要求
  systemRequirements: [
    '操作系统：Windows 7/8/10 64位',
    '处理器：Intel i5或同等配置',
    '内存：8GB RAM',
    '显卡：GTX 1060或同等配置',
    '存储空间：50GB可用空间'
  ],

  // 社区平台
  communityPlatforms: [
    { title: '官方论坛', desc: '参与讨论，分享心得', button: '进入论坛' },
    { title: '官方微博', desc: '关注官方微博，获取最新资讯', button: '关注微博' },
    { title: '客服中心', desc: '遇到问题？联系客服获得帮助', button: '联系客服' }
  ],

  // 首页 Hero 区域
  hero: {
    title: '代号：真修仙',
    subtitle: '真·旗舰产品，敬请期待'
  },

  // 首页产品特色
  features: [
    { title: '核心功能', desc: '使用最新算法解决客户需求' },
    { title: '使用体验', desc: '流畅交互，丝滑享受' },
    { title: '社区建设', desc: '提供稳定平台吸引优质用户' }
  ],

  // 首页快捷入口
  additionalFeatures: [
    { title: '关于我们', desc: '了解公司信息', path: '/cn/about' },
    { title: '加入我们', desc: '招聘信息', path: '/cn/contact' }
  ],

  // 关于页面
  about: {
    intro: '盛剑游是一家专注于高品质产品开发与运营的创新科技公司。我们致力于为全球用户提供优质产品，将传统文化与现代科技完美融合。',
    team: '公司拥有一支经验丰富、充满激情的核心团队，成员来自国内外知名科技公司，具备丰富的产品研发、运营和市场推广经验。我们注重人才培养和团队建设，为员工提供广阔的发展空间。',
    philosophy: '我们坚持"品质为本，创新为魂"的发展理念，在保证产品质量的同时，不断探索新的技术，力求在竞争激烈的市场环境中脱颖而出。'
  },

  // 新闻列表
  newsList: [
    { id: 1, title: '新版本即将上线', date: '2023-10-01', summary: '全新版本即将到来，更多内容敬请期待！' },
    { id: 2, title: '国庆活动开启', date: '2023-09-25', summary: '国庆长假期间，游戏内将开启丰富活动，奖励多多！' },
    { id: 3, title: '服务器维护公告', date: '2023-09-20', summary: '为了提供更好的游戏体验，服务器将于凌晨进行维护。' }
  ],

  // 游戏特色
  gameFeatures: [
    { title: '职业系统', desc: '多种职业选择，每种职业都有独特的技能和玩法' },
    { title: 'PVP竞技', desc: '激烈的玩家对战，展现你的操作技巧' },
    { title: '副本挑战', desc: '丰富的副本内容，团队合作挑战强大BOSS' },
    { title: '装备系统', desc: '多样化的装备获取和强化系统' }
  ],

  // 新闻轮播数据
  carouselNews: [
    { title: '公司简介', date: '2023-08-25', url: '/cn/about' }
  ]
}
